import React from "react";
import { BotonAddCliente2, BotonAddDeliveryComprobante, BotonAddDireccionDelivery } from "../Plantillas/Botones";
import _ from 'lodash';
import './Delivery.css'
import Modal from "./DeliveryModal";
import ModalAgregarCLiente from "./DeliveryAgregarCliente";

class BuscarClienteDelivery extends React.Component {
    constructor(props){
        super(props)
        this.state ={
            modalAbierto: false
        }
    }

    cerrarModal = () => {
        this.setState({
            modalAbierto: false,
        });
    }

    handleClickNuevo = () => {
        this.setState({
            modalAbierto: true
        })
    }
    
    render(){
        const { dataCliente, selectedDireccion, modalAbierto, Documento, 
                onDireccionChange, handleClickNuevaDireccion, hideAddCliente, 
                hideAddDireccion, setActiveInputDoc } = this.props;
        
        const cliente = Array.isArray(dataCliente) && dataCliente.length > 0 
            ? dataCliente[0] 
            : dataCliente || {};
        
        const direcciones = cliente.Direcciones || [];
        const hasCliente = cliente && cliente.IdCliente;
        const celular = cliente.celular || '';
        const razonSocial = cliente.RazonSocial || '';

        return(
            <div className="abed__cliente_delivery-container" style={this.props.style}>
                <div className="abed__cliente_delivery">
                    <label className="abed__delivery-label">CLIENTE: </label>
                    {hasCliente && (
                        <label className="abed__cliente_info"> {razonSocial} -{celular}</label>
                    )}
                </div>
                
                <div className="abed__cliente_delivery-buscar">
                    <div className="abed__documento-input-container">
                        <input 
                            className="abed__documento-input"
                            name="Documento"
                            type="text"
                            value={Documento}
                            placeholder="DNI/RUC"
                            required
                            onFocus={(e) => setActiveInputDoc && setActiveInputDoc(e, "Documento")}  
                        />
                    </div>
                    
                    <div className="button-container">
                        <BotonAddCliente2
                            hidden={_.isUndefined(hideAddCliente) ? false : hideAddCliente}
                            onClick={this.handleClickNuevo}
                            title="Nuevo Cliente"
                            className="add-client-btn"
                        />
                    </div>
                </div>
                
                {hasCliente && (
                    <div className="abed__direccion_cliente">
                        <div className="abed__select_direccion">
                            <select 
                                required 
                                className="input_sin_linea" 
                                name="IdDireccion"
                                value={selectedDireccion || ''}
                                onChange={onDireccionChange}
                            >
                                <option value="">Seleccione una dirección</option>
                                {direcciones.map((direccion, index) => (
                                    <option 
                                        key={direccion.IdDireccion || index} 
                                        value={direccion.IdDireccion || index}
                                    >
                                        {direccion.Direccion} 
                                        {direccion.Referencia && ` - ${direccion.Referencia}`}
                                        {direccion.Principal && " (Principal)"}
                                    </option>
                                ))}
                            </select>
                        </div>
{/*                         
                        <div className="button-container">
                            <BotonAddDireccionDelivery
                                hidden={_.isUndefined(hideAddDireccion) ? false : hideAddDireccion}
                                onClick={this.handleClickNuevo}
                                title="Nueva Dirección"
                                className="add-address-btn"
                            />
                        </div> */}
                    </div>
                )}
                
                {hasCliente && direcciones.length === 0 && (
                    <div className="abed__sin_direcciones">
                        <p>Este cliente no tiene direcciones registradas.</p>
                    </div>
                )}

                <div className="abed__cliente_delivery">
                    <label className="abed__delivery-label ">FACTURA/BOLETA:</label>
                    {hasCliente && celular && (
                        <label className="abed__cliente_info"> {cliente.RazonSocial} - {celular}</label>
                    )}
                </div>
                
                <div className="abed__cliente_delivery-buscar">
                    <div className="abed__documento-input-container">
                        <input 
                            className="abed__documento-input"
                            name="Documento"
                            type="text"
                            value={this.props.Documento}
                            placeholder="DNI/RUC"
                            required
                            onFocus={(e) => this.props.setActiveInputDoc && this.props.setActiveInputDoc(e, "Documento")}  
                        />
                    </div>
                    
                    <div className="button-container">
                        <BotonAddDeliveryComprobante
                            hidden={_.isUndefined(this.props.hideAddCliente) ? false : (this.props.hideAddCliente)}
                            onClick={this.props.handleClickNuevo}
                            title="Nuevo Cliente"
                            className="add-client-btn"
                        />
                    </div>
                </div>
                <Modal
                    isOpen={this.state.modalAbierto}
                    onClose={this.cerrarModal}
                >
                    <h6>Agregar Nuevo Cliente Delivery</h6>
                    <ModalAgregarCLiente 
                        onSuccess={() => {
                            this.cerrarModal();
                            if (this.props.onClienteAdded) {
                                this.props.onClienteAdded();
                            }
                        }}
                    />
                </Modal>
            </div>
        )
    }
}

export default BuscarClienteDelivery;